'use client';
import React from 'react';
import dynamic from 'next/dynamic';

if (process.env.NODE_ENV === 'development') {
    if (typeof window !== 'undefined') {
        // require("../mock/mock.js");
    }
}

console.log("TripKit React SHA:", process.env.NEXT_PUBLIC_TRIPKIT_REACT_SHA);

const TripPlannerAppClientOnly = dynamic(() => import('./TripPlannerApp'), { ssr: false })

//------------------------------------------------------------------------------
// Hardcoded keys for development. Comment out for prod compile and for commit.
// const devCredentials = require("./dev-credentials");
// const testAccount = window.location.host.includes("localhost") && devCredentials.mauroAdminAccountMiRide;
// const testAccount = window.location.host.includes("localhost") && devCredentials.mauroAdminAccountN4Connect;
// const testAccount = window.location.host.includes("localhost") && devCredentials.mauroTestDrt1AdminAccount;
// const testAccount = window.location.host.includes("localhost") && devCredentials.mauroTestDrt2AdminAccount;
// const testAccount = window.location.host.includes("localhost") && devCredentials.mauroAdminAccountUQ;
//------------------------------------------------------------------------------
// const testAccount = undefined;

export default () =>
    <TripPlannerAppClientOnly />